<div class="candidato-selector">
  <small class="candidatos-encontrados">
    {{ 'candidatos_encontrados' | transloco:{ quantidade: candidatos.length } }}
  </small>
  <p-dropdown
    [options]="candidatos"
    optionLabel="nome"
    [ngModel]="candidatoSelecionado"
    (onChange)="onChange($event)"
    placeholder="{{'selecionar_produto_candidato' | transloco}}"
    styleClass="w-100">
    <ng-template pTemplate="selectedItem" let-candidato>
      <div class="candidato-item" *ngIf="candidato">
        <img *ngIf="candidato.imagem?.url" [src]="candidato.imagem?.url" [alt]="candidato.nome" class="candidato-thumb">
        <span class="candidato-nome">{{ candidato.nome }}</span>
      </div>
    </ng-template>
    <ng-template pTemplate="item" let-candidato>
      <div class="candidato-item">
        <img *ngIf="candidato.imagem?.url" [src]="candidato.imagem?.url" [alt]="candidato.nome" class="candidato-thumb">
        <span class="candidato-nome">{{ candidato.nome }}</span>
      </div>
    </ng-template>
  </p-dropdown>
</div>
